export default {
  export:{
    conceptscheme: {
      title: "Экспорт",
      description: "Выберите, какие разделы включить в экспорт:",
      format: "Формат экспорта:",
      formats: { turtle: "Turtle (*.ttl)", nTriples: "N-Triples (*.n3)" },
      includeConcepts: "Включить в экспорт детальную информацию о концептах",
      includeRelated: "Включить в экспорт детальную информацию о связанных элементах (при наличии)",
      preparing: "Подготовка…",
      fetchingIriList: "Получение списка IRI…",
      fetchingData: "Получение данных {{name}}",
      exporting: "Экспорт: {{title}}…",
      packingZip: "Упаковка ZIP…",
      zipReady: "ZIP готов. Начинаю скачивание…",
      done: "Готово.",
      executionLog: "Журнал выполнения",
      emptyLog: "Лог пуст.",
      exportError: "Ошибка экспорта",
      downloadLink: "Ссылка на скачивание:",
      download: "Скачать {{filename}}",
      downloadHint: "Если скачивание не началось автоматически, нажмите ссылку выше.",
      cancel: "Отмена",
      close: "Закрыть",
      export: "Экспорт",
      log: {
        started: "Старт экспорта ZIP.",
        exporting: "Экспорт: {{title}}",
        searchingRelated: "Поиск связанных объектов в {{id}}",
        fileAdded: "Добавлен файл: {{file}}",
        zipCreated: "ZIP сформирован: {{filename}}",
        completed: "Экспорт завершён.",
        error: "Ошибка экспорта: {{error}}"
      }
    }
  },
  import: {
    conceptscheme: {
      title: "Импорт объекта",
      close: "Закрыть",
      cancel: "Отмена",
      import: "Импорт",
      selectFile: "Выбрать файл",
      file: "Файл: {{filename}}",
      noFileSelected: "Файл не выбран",
      whatToImport: "Что импортировать:",
      importSchemes: "Импорт справочника(ов)",
      deleteBeforeImport: "Удалить перед импортом",
      replacePurlServer: "Заменить PURL сервер",
      sourcePurlServer: "Исходный PURL сервер",
      targetPurlServer: "Целевой PURL сервер",
      foundSchemes: "Найдено: справочники — {{count}}",
      error: "Ошибка",
      success: "Импорт выполнен успешно.",
      status: {
        preparing: "Подготовка...",
        checkingZip: "Проверка ZIP-архива...",
        readingArchive: "Чтение архива...",
        searchingManifest: "Поиск export.json...",
        readingManifest: "Чтение export.json...",
        checkingManifestFiles: "Проверка файлов из export.json...",
        analysisComplete: "Анализ завершён. Выберите, что импортировать.",
        extractingData: "Распаковка данных...",
        importingObject: "Импорт объекта...",
        objectImported: "Объект импортирован.",
        preparingImport: "Подготовка импорта...",
        importComplete: "Импорт завершён."
      },
      errors: {
        import: "Ошибка импорта.",
        unknownRdfFormat: "Не удалось определить RDF-формат файла \"{{filename}}\".",
        sparql: "Ошибка выполнения SPARQL запроса.",
        notZip: "Выбранный файл не является ZIP-архивом.",
        emptyArchive: "Архив пуст или не содержит файлов.",
        manifestMissing: "В архиве отсутствует обязательный файл export.json.",
        manifestInvalidJson: "Не удалось распарсить export.json как JSON.",
        manifestNotArray: "export.json должен содержать JSON-массив записей.",
        noManifestItems: "В export.json не найдено ни одного элемента с полем file.",
        filesMissing: "В архиве отсутствуют файлы, перечисленные в export.json: {{files}}",
        graphMissing: "Граф для импорта не указан.",
        analysis: "Ошибка анализа архива.",
        objectImport: "Импорт объекта: {{error}}",
        nothingSelected: "Ничего не выбрано для импорта.",
        purlRequired: "Для замены PURL укажите исходный и целевой PURL сервер."
      },
      warnings: {
        nothingToImport: "Нечего импортировать",
        uploadAnotherFile: "Загрузите другой файл",
        configurationError: "Ошибка настройки",
        configurePurl: "Уберите замену PURL сервера или настройте замену PURL."
      }
    }
  }
}
